import React, { Component } from 'react';
import Modal from 'react-modal';
import moment from 'moment';

class TimeSlots extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={this.props.closeModal}
                className={'modal-width'}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-dateselect">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 mb-6 text-lg font-medium text-white">
                                Choose a Time
                            </h3>
                            <button type="button" onClick={() => this.props.closeModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        {this.props.timeSlots && this.props.timeSlots.length ? (
                            moment(this.props.startDate).format('DDD') ===
                                moment(new Date()).format('DDD') &&
                            moment(
                                this.props.timeSlots &&
                                    this.props.timeSlots[
                                        this.props.timeSlots && this.props.timeSlots.length - 1
                                    ].startTime
                            ).format('HH:mm') <= moment(new Date()).format('HH:mm') ? (
                                <div className="flex items-center justify-center text-white">
                                    No slots available
                                </div>
                            ) : (
                                <div className="grid grid-cols-3 gap-2 lg:grid-cols-7 md:grid-cols-4">
                                    {/* eslint-disable array-callback-return  */}
                                    {this.props.timeSlots.map((res, index) => {
                                        const isSelected = this.props.timeApp.findIndex((i) => {
                                            return i.slotId === res.id;
                                        });
                                        if (!res.booked) {
                                            if (
                                                moment(this.props.startDate).format('DDD') ===
                                                moment(new Date()).format('DDD')
                                            ) {
                                                if (
                                                    moment(res.startTime).format('HH:mm') >=
                                                    moment(new Date()).format('HH:mm')
                                                ) {
                                                    return (
                                                        <button
                                                            key={index}
                                                            className={`font-normal px-1 rounded-full h-8 whitespace-nowrap hover:bg-primary hover:text-white ${
                                                                isSelected === -1
                                                                    ? 'bg-dark_ashyshade text-white'
                                                                    : 'bg-UIprimary text-white'
                                                            }`}
                                                            onClick={() => {
                                                                this.props.handleChangeTime(
                                                                    res.id,
                                                                    res.startTime
                                                                );
                                                            }}
                                                        >
                                                            {moment(res.startTime).format(
                                                                'hh:mm A'
                                                            )}
                                                        </button>
                                                    );
                                                }
                                            } else {
                                                return (
                                                    <button
                                                        key={index}
                                                        className={`font-normal px-1 rounded-full h-8 whitespace-nowrap hover:bg-primary hover:text-white ${
                                                            isSelected === -1
                                                                ? 'bg-dark_ashyshade text-white'
                                                                : 'bg-UIprimary text-white'
                                                        }`}
                                                        onClick={() => {
                                                            this.props.handleChangeTime(
                                                                res.id,
                                                                res.startTime
                                                            );
                                                        }}
                                                    >
                                                        {moment(res.startTime).format('hh:mm A')}
                                                    </button>
                                                );
                                            }
                                        }
                                    })}
                                </div>
                            )
                        ) : (
                            <div className="flex items-center justify-center text-white">
                                No slots available
                            </div>
                        )}

                        {/* <div className="flex items-center justify-end pt-6 space-x-2">
              <button
                data-modal-hide="defaultModal"
                className={this.props.timeApp && this.props.timeApp.length ? "text-white bg-primary rounded-lg font-semibold text-base w-28 py-2" :
                  "text-red border-red ring-1 ring-inset ring-red bg-white rounded-lg font-semibold text-base w-28 py-2"
                }
                onClick={() => this.props.closeModal()}
              >
                {this.props.timeApp && this.props.timeApp.length
                  ? "Save"
                  : "Cancel"}
              </button>
            </div> */}
                    </div>
                </div>
            </Modal>
        );
    }
}
export default TimeSlots;
